import { render, staticRenderFns } from "./ModifyVinculationForm.vue?vue&type=template&id=c248abee"
import script from "./ModifyVinculationForm.vue?vue&type=script&lang=js"
export * from "./ModifyVinculationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports